import React, { Component } from "react";
import DataTable from 'react-data-table-component';
import { SolidaridadDetalle } from "./SolidaridadDetalle"
import history from "../login/history";
import ButtonLink from "../../generico/ButtonLink";
import ConfigService from "../../../services/configuracion/ConfigService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoneyBill } from "@fortawesome/free-solid-svg-icons";

const PAGAR_SOLIDARIDAD = 72;

export default class SolidaridadSocio extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listaSolidaridad: [],
            detalles: [],
        };
    }

    componentDidMount() {

    }

    getColumn() {
        return [
            // {
            //     name: "Integrado",
            //     selector: "integrado",
            // },
            {
                name: "Obligación hasta fin de año",
                selector: row => row.obligacionAnho,
                // right: true
            },
            {
                name: "Obligación hasta fin de mes",
                selector: row => row.obligacionMes,
                right: true
            },
            {
                name: "Obligación a la fecha",
                selector: row => row.obligacionFecha,
                right: true
            },
            {
                cell: (row) => (
                    <ButtonLink
                        className="btn btn-cu-terciary btn-sm"
                        onClick={this.pagarSolidaridad}
                        url={ConfigService.getPathById(PAGAR_SOLIDARIDAD)?.url}>
                        <FontAwesomeIcon icon={faMoneyBill} /> Pagar
                    </ButtonLink>

                ),

            }
        ];
    }
    
    pagarSolidaridad = (url) => {
        history.push(url);
        window.location.reload();
    }


    render() {

        return (
            <div>
                <div className="form-group">
                    <div className="table-responsive">
                        <DataTable
                            noHeader={true}
                            pagination={false}
                            columns={this.getColumn()}
                            data={this.props.solidaridad}
                            noDataComponent="no hay registros para mostrar"
                            responsive={true}
                            expandableRows
                            expandableRowsComponent={SolidaridadDetalle}
                            expandableRowsComponentProps={{ detalle: this.props.detalle, cuota: "TODOS" }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
